const COOKIES = {
  BOKADIREKT_COOKIE_PREFERENCES_MP: 'BokadirektCookiePreferencesMP',
} as const;

export default COOKIES;
